module.exports = __webpack_public_path__ + "img/poney_skear.883a0daa.png";